import store from "@/state/store";

const EmptyRouterView = {
    render(c) {
        return c("router-view");
    },
}; // ใช้สำหรับการแสดงผลหน้า children

export default [
    // ANCHOR login
    {
        path: "/login",
        name: "login",
        component: () => import("../views/pages/account/login.vue"),
        meta: {
            type: "default",
        },
    },
    // ANCHOR login-invite
    {
        path: "/login/:invite_key", // url ที่จะเข้าถึงหน้า
        name: "login-key", // ใช้อ้างอิง path this.$router.push
        component: () => import("../views/pages/account/login.vue"), // หน้าที่แสดงผล
        meta: {
            authRequired: false, // ต้องการ login หรือไม่ (ถ้าต้องการ ค่อยไปเช็ค type เพิ่มเติม)
            type: "default", // เงื่อนไขการเข้าถึงหน้า (default ไม่ต้องการสิทธิ์, xxxx_flag ต้องการสิทธิ์)
        },
    },
    // ANCHOR invite
    {
        path: "/invite/:invite_key",
        name: "invite-key",
        component: () => import("../views/pages/account/invite.vue"),
        meta: {
            authRequired: true,
            type: "default",
        },
    },
    // ANCHOR register
    {
        path: "/register",
        name: "register",
        component: () => import("../views/pages/account/register.vue"),
        meta: {
            type: "default",
        },
    },
    {
        path: "/register/:invite_key",
        name: "register-key",
        component: () => import("../views/pages/account/register.vue"),
        meta: {
            type: "default",
        },
    },
    // ANCHOR term-and-privacy
    {
        path: "/term-and-privacy",
        name: "term-and-privacy",
        component: () => import("../views/pages/account/policyandagree.vue"),
        meta: {
            type: "default",
        },
    },
    // ANCHOR show-env
    // {
    //     path: "/version-program",
    //     name: "version-program",
    //     component: () => import("../views/pages/version-program.vue"),
    //     meta: {
    //         type: "default",
    //     },
    // },
    // ANCHOR forgot
    {
        path: "/forgot",
        component: EmptyRouterView,
        meta: {
            type: "default",
        },
        children: [
            {
                path: "password",
                name: "forgot-password",
                component: () => import("../views/pages/account/forgot-password.vue"),
            },
            {
                path: "check-otp",
                name: "forget-check-otp",
                component: () => import("../views/pages/account/forgotpage/otp-page.vue"),
            },
            {
                path: "new-password-confirm",
                name: "forgot-new-password-confirm",
                component: () => import("../views/pages/account/forgotpage/newpwd-page.vue"),
            },
        ],
    },
    //ANCHOR not-found
    {
        path: "/not-found",
        name: "not-found",
        meta: {
            type: "default",
        },
        component: () => import("../views/pages/utility/404.vue"),
    },
    {
        path: "/:pathMatch(.*)*",
        component: () => import("../views/pages/utility/404.vue"),
        meta: {
            type: "default",
        },
    },
    //ANCHOR home
    {
        path: "/",
        name: "home",
        meta: {
            authRequired: true,
            type: "default",
        },
        component: () => import("../views/pages/dashboard/index.vue"),
    },
    //ANCHOR topup
    {
        path: "/topup",
        meta: {
            authRequired: true,
        },
        component: EmptyRouterView,
        children: [
            {
                path: "delivery",
                name: "topup-delivery",
                component: () => import("../views/pages/topup/delivery.vue"),
                meta: {
                    type: "advanced_topup_flag",
                },
            },
            {
                path: "service",
                name: "topup-service",
                component: () => import("../views/pages/topup/service.vue"),
                meta: {
                    type: "advanced_topup_flag",
                },
            },
        ],
    },
    //ANCHOR order
    {
        path: "/order",
        meta: {
            authRequired: true,
        },
        component: EmptyRouterView,
        children: [
            {
                path: "create",
                name: "order-create",
                component: () => import("../views/pages/order/create.vue"),
                meta: {
                    type: "advanced_order_flag",
                },
            },
            {
                path: "import",
                name: "order-import",
                component: () => import("../views/pages/order/import.vue"),
                meta: {
                    type: "advanced_order_flag",
                },
            },
            {
                path: "list",
                name: "order-list",
                component: () => import("../views/pages/order/list.vue"),
                meta: {
                    type: "order_flag",
                },
            },
            {
                path: "list/:id",
                name: "order-list-id",
                component: () => import("../views/pages/order/list-id.vue"),
                meta: {
                    type: "order_flag",
                },
            },
            {
                path: "pickup",
                name: "order-pickup",
                component: () => import("../views/pages/order/pickup.vue"),
                meta: {
                    type: "pickup_point_flag",
                },
            },
            {
                path: "parcel-handover-form",
                name: "order-parcel-handover-form",
                component: () =>
                    import("../views/pages/order/parcel-handover-form.vue"),
                meta: {
                    type: "order_flag",
                },
            },
        ],
    },
    //ANCHOR finance
    {
        path: "/finance",
        meta: {
            authRequired: true,
        },
        component: EmptyRouterView,
        children: [
            {
                path: "wallet/topup",
                name: "finance-wallet-topup",
                component: () => import("../views/pages/finance/wallet/topup.vue"),
                meta: {
                    type: "finance_flag",
                },
            },
            {
                path: "wallet/transaction",
                name: "finance-wallet-transaction",
                component: () => import("../views/pages/finance/wallet/transaction.vue"),
                meta: {
                    type: "finance_flag",
                },
            },
            {
                path: "wallet/service-transaction",
                name: "finance-wallet-service-transaction",
                component: () => import("../views/pages/finance/wallet/service-transaction.vue"),
                meta: {
                    type: "finance_flag",
                },
            },
            {
                path: "wallet/cod",
                name: "finance-wallet-cod",
                component: () => import("../views/pages/finance/wallet/cod.vue"),
                meta: {
                    type: "advanced_finance_flag",
                },
            },
            {
                path: "cod/status",
                name: "finance-cod-status",
                component: () => import("../views/pages/finance/cod/status.vue"),
                meta: {
                    type: "order_flag",
                },
            },
            {
                path: "cod/settlement",
                name: "finance-cod-settlement",
                component: () => import("../views/pages/finance/cod/settlement.vue"),
                meta: {
                    type: "advanced_finance_flag",
                },
            },
            {
                path: "cod/settlement/:id",
                name: "finance-cod-settlement-id",
                component: () => import("../views/pages/finance/cod/settlement-id.vue"),
                meta: {
                    type: "advanced_finance_flag",
                },
            },
            {
                path: "other-fee",
                name: "finance-other-fee",
                component: () => import("../views/pages/finance/other-fee.vue"),
                meta: {
                    type: "tax_invoice_flag",
                },
            },
            {
                path: "document/invoice",
                name: "finance-document-invoice",
                component: () => import("../views/pages/finance/document/invoice.vue"),
                meta: {
                    type: "tax_invoice_flag",
                },
            },
            {
                path: "document/invoice/:id",
                name: "finance-document-invoice-id",
                component: () => import("../views/pages/finance/document/invoice-id.vue"),
                meta: {
                    type: "tax_invoice_flag",
                },
            },
            {
                path: "document/credit-note",
                name: "finance-document-credit-note",
                component: () => import("../views/pages/finance/document/credit-note.vue"),
                meta: {
                    type: "tax_invoice_flag",
                },
            },
            {
                path: "document/credit-note/:id",
                name: "finance-document-credit-note-id",
                component: () => import("../views/pages/finance/document/credit-note-id.vue"),
                meta: {
                    type: "tax_invoice_flag",
                },
            },
            {
                path: "document/tax-invoice",
                name: "finance-document-tax-invoice",
                component: () => import("../views/pages/finance/document/tax-invoice.vue"),
                meta: {
                    type: "tax_invoice_flag",
                },
            },
            {
                path: "document/tax-invoice/:id",
                name: "finance-document-tax-invoice-id",
                component: () => import("../views/pages/finance/document/tax-invoice-id.vue"),
                meta: {
                    type: "tax_invoice_flag",
                },
            }
        ],
    },
    //ANCHOR redirect: เดิม /options/* -> /setting/*
    {
        path: "/options",
        children: [
            {
                path: "connect-api",
                redirect: { name: "setting-api" },
            },
            {
                path: "address",
                redirect: { name: "setting-pickup-point" },
            },
        ],
    },
    //ANCHOR settings
    {
        path: "/setting",
        meta: {
            authRequired: true,
        },
        component: EmptyRouterView,
        children: [
            {
                path: "pickup-point",
                name: "setting-pickup-point",
                component: () => import("../views/pages/setting/pickup-point.vue"),
                meta: {
                    type: "pickup_point_flag",
                },
            },
            {
                path: "config",
                name: "setting-config",
                component: () => import("../views/pages/setting/config.vue"),
                meta: {
                    type: "setting_flag",
                },
            },
            {
                path: "api",
                name: "setting-api",
                component: () => import("../views/pages/setting/api.vue"),
                meta: {
                    type: "open_api_flag",
                },
            },
        ],
    },
    //ANCHOR user
    {
        path: "/user",
        meta: {
            authRequired: true,
        },
        component: EmptyRouterView,
        children: [
            {
                path: "profile",
                name: "user-profile",
                component: () => import("../views/pages/user/profile.vue"),
                meta: {
                    type: "setting_flag",
                },
            },
            {
                path: "employee",
                name: "user-employee",
                component: () => import("../views/pages/user/employee.vue"),
                meta: {
                    type: "account_child_flag",
                },
            },
            {
                path: "delete-account",
                name: "user-delete-account",
                component: () => import("../views/pages/user/delete-account.vue"),
                meta: {
                    type: "advanced_account_child_flag",
                },
            },
            {
                path: "permission",
                name: "user-permission",
                component: () => import("../views/pages/user/permission.vue"),
                meta: {
                    type: "default",
                },
            },
            //ANCHOR switch-account
            {
                path: "switch-account",
                name: "user-switch-account",
                meta: {
                    type: "default",
                },
                component: () => import("../views/pages/user/switch-account.vue"),
            },
            // ANCHOR logout
            {
                path: "logout",
                name: "user-logout",
                component: EmptyRouterView,
                meta: {
                    type: "default",
                    // async beforeResolve() {
                    //     await store.dispatch('auth/logOut');
                    // },
                },
            },
        ],
    },
];
